import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import Text from '@navent-jobs/ui-kit/components/text'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import { ThemeContext } from 'styled-components'
import { ComponentContainer } from './mixins'
import features from '../../../../constants/features-per-country'
import { SITE_ID } from '../../../../constants'

const Component = () => {
  const { t } = useTranslation()
  const { colors } = useContext<{ colors }>(ThemeContext)
  const cvMatchEnabled = features[SITE_ID ?? 'BMAR']?.fichaAviso?.match

  if (!cvMatchEnabled) {
    return <></>
  }

  return (
    <ComponentContainer>
      <Icon name="icon-light-target" size="20" color={colors.extra.normal} />
      <Text size="sm" fontWeight="semibold" variant="extra">
        {t('fichaAviso.cvMatch.text', { cv: t('cv') })}
      </Text>
    </ComponentContainer>
  )
}

export default Component
